import SentimentCard from '../../components/SentimentCard';
import useScan from '../../hooks/useScan';

const CompetitorSentimentCard = () => {
  const { data } = useScan();
  const sentimentCompetitor = data?.sentiment?.topCompetitor;

  return (
    <SentimentCard
      title="Competitor sentiment"
      data={sentimentCompetitor}
      // https://www.figma.com/design/zH43jZJuvZyPaqrod8lG5u?node-id=2-5#1353634805
      tooltip="Percentage of positive versus negative keywords in your query results related to your competitor's brand."
    />
  );
};

export default CompetitorSentimentCard;
